import * as React from "react";
import * as types from "../../constants/actionTypes";
import { connect } from "react-redux";


class AdalTokenRefresh extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            timerHandle: null
        };
        this.StartTimer = this.StartTimer.bind(this);
        this.TimerTick = this.TimerTick.bind(this);
        this.EndTimer = this.EndTimer.bind(this);
    }

    componentDidMount() {
        this.StartTimer();
    }

    componentDidUpdate(prevState, prevProps) {
        this.StartTimer();
    }

    componentWillUnmount() {
        this.EndTimer();
    }

    StartTimer() {
        var { timerHandle } = this.state;
        if (!timerHandle) {
            timerHandle = window.setInterval(this.TimerTick, window.serverData.data.refreshTokenTimer);
            this.setState({ timerHandle: timerHandle });
        }
    }

    EndTimer() {
        const { timerHandle } = this.state;
        if (timerHandle) {
            window.clearInterval(timerHandle);
            this.setState({ timerHandle: null });
        }
    }

    TimerTick() {
        const { RefreshData } = this.props;
        if (RefreshData) {
            RefreshData();
        }
    }

    render() {
        return (
            <React.Fragment />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        //bffToken: state.domain.idt,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        RefreshData: () => {
            dispatch({ type: types.ADAL_TOKEN_REFRESH, NoSync: true });
        },

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdalTokenRefresh);


